import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {LicensedAgent} from "../../../shared/interface/licensed-agent";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AffiliateCode} from "../../../shared/interface/affiliateCode";
import {ActivatedRoute} from "@angular/router";
import {LicensedAgentService} from "../../../shared/services/licensed-agent.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {AffiliateCodeService} from "../../../shared/services/affiliate-code.service";
import {takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-affiliate-code-details',
  templateUrl: './affiliate-code-details.component.html',
  styleUrls: ['./affiliate-code-details.component.scss']
})
export class AffiliateCodeDetailsComponent implements OnInit, OnDestroy {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  affiliateCodeId: string;
  affiliateCodeObject?: AffiliateCode;
  affiliateCode: ReplaySubject<AffiliateCode> = new ReplaySubject<AffiliateCode>(1);
  userPermissions: ReplaySubject<UserPermissions>;
  modify = false;

  constructor(
    private route: ActivatedRoute,
    private affiliateCodeService: AffiliateCodeService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();

  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.affiliateCodeId = params.id;
        this.loadAffiliateCode();
      });
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadAffiliateCode(): void {
    this.affiliateCodeService.get(this.affiliateCodeId).subscribe((affiliateCode: AffiliateCode) => {
      this.affiliateCode.next(affiliateCode);
      this.affiliateCodeObject = affiliateCode;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych', error.status.toString(), {
        duration: 2000
      });
    });
  }
}
